import { ReactNode } from "react";

interface DropdownMenuProps {
  children: ReactNode;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

const DropdownMenu = ({ children, onMouseOut, onMouseOver }: DropdownMenuProps) => {
  return (
    <div className="dropdown" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      {children}
    </div>
  );
};

export default DropdownMenu;
